import React from 'react';
import { BtnModalTable } from '../../styled-components';

function ActionsField({ data, toggleHistoryModal }) {
  return (
    <>
      <BtnModalTable
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          toggleHistoryModal(data._id);
        }}
      >
        VISUALIZZA STORICO
      </BtnModalTable>
    </>
  );
}

export default ActionsField;
